export enum PermissionEnum {
  // Section
  SectionList = 'c100b9db-6ad3-4125-9ae6-40cd568ea5cf',
  SectionDelete = '10667e42-77cc-467d-afcc-519eaa02d2e5',
  SectionAdd = '2494a50a-0fa5-412f-a5f5-01ad4ed1f64f',
  SectionEdit = 'a556c855-8a61-4d4d-b364-09e68c04e6c3',

  // // StackholderDepartment
  // StackholderDepartmentList = "d233b7ab-8d2a-4f1a-9f9b-4b7d8d9a9e61",
  // StackholderDepartmentDelete = "e849bd12-341a-4abf-b8f2-3a73e1d5a123",
  // StackholderDepartmentAdd = "c34f5a17-9fa0-463d-b6a7-982d4a73c2a7",
  // StackholderDepartmentEdit = "b27f3b69-8a6d-4c1a-b4b1-1a8c7d92c9f0",

  // // StrategicObjective
  // StrategicObjectiveList = "a12c4b8e-7b5a-4e5a-b4c2-12345d6f789a",
  // StrategicObjectiveDelete = "b23d5c9f-8c6b-4f6b-c5d3-23456e7f890b",
  // StrategicObjectiveAdd = "c34e6d0f-9d7c-5e7c-d6e4-34567f8a901c",
  // StrategicObjectiveEdit = "d45f7e1a-0e8d-6e8d-e7f5-45678f9b012d",

  // TaskComment
  TaskCommentList = 'e56g8h1j-1f9e-7i9e-f8g6-56789h0j123e',
  TaskCommentDelete = 'f67h9i2k-2g0f-8j0f-g9h7-67890i1k234f',
  TaskCommentAdd = 'g78i0j3l-3h1g-9k1g-h0i8-78901j2l345g',
  TaskCommentEdit = 'h89j1k4m-4i2h-0l2h-i1j9-89012k3m456h',

  // StakeHolder
  // StakeHolderList = "f01b9fdb-6ac3-4125-9ae6-40cd568ea6cf",
  // StakeHolderDelete = "a1237f42-77cc-467d-afcc-519eaa02d2a7",
  // StakeHolderAdd = "d456c50a-0fa5-412f-a5f5-01ad4ed1f65e",
  // StakeHolderEdit = "c678c755-8a61-4d4d-b364-09e68c04e7d4",

  // StackholderMember
  StackholderMemberList = 'c34a6b9f-9a7c-5d7a-a6b4-34567b8c901d',
  StackholderMemberDelete = 'd45b7c0e-0c8d-6a8d-a7b5-45678c9d012e',
  StackholderMemberAdd = 'e56c8d1f-1d9e-7b9e-b8c6-56789d0e123f',
  StackholderMemberEdit = 'f67d9e2a-2e0f-8c0f-c9d7-67890e1f234a',

  // TaskRelation
  TaskRelationList = 'a90b2c5d-5f3a-1d3a-a2b0-90123c4d567b',
  TaskRelationDelete = 'b01c3d6e-6a4b-2e4b-b3c1-01234d5e678c',
  TaskRelationAdd = 'c12d4e7f-7b5c-3f5c-c4d2-12345e6f789d',
  TaskRelationEdit = 'd23e5f8a-8c6d-4a6d-d5e3-23456f7a890e',

  // // SourceMarket
  // SourceMarketList = "e34f6a9b-9d7e-5b7e-e6f4-34567a8b901f",
  // SourceMarketDelete = "f45a7b0c-0e8f-6c8f-f7a5-45678b9c012a",
  // SourceMarketAdd = "a56b8c1d-1f9a-7d9a-a8b6-56789c0d123b",
  // SourceMarketEdit = "b67c9d2e-2a0b-8e0b-b9c7-67890d1e234c",

  // Project
  ProjectList = 'c78d0e3f-3b1c-9f1c-c0d8-78901e2f345d',
  ProjectDelete = 'd89e1f4a-4c2d-0a2d-d1e9-89012f3a456e',
  ProjectAdd = 'e90f2a5b-5d3e-1b3e-e2f0-90123a4b567f',
  ProjectEdit = 'f01a3b6c-6e4f-2c4f-f3a1-01234b5c678a',

  // ProjectTask
  ProjectTaskList = 'a12b4c7d-7f5a-3d5a-a4b2-12345c6d789b',
  ProjectTaskDelete = 'b23c5d8e-8a6b-4e6b-b5c3-23456d7e890c',
  ProjectTaskAdd = 'c34d6e9f-9b7c-5f7c-c6d4-34567e8f901d',
  ProjectTaskEdit = 'd45e7f0a-0c8d-6a8d-d7e5-45678f9a012e',

  // // Persona
  // PersonaList = "e56f8a1b-1d9e-7b9e-e8f6-56789a0b123f",
  // PersonaDelete = "f67a9b2c-2e0f-8c0f-f9a7-67890b1c234a",
  // PersonaAdd = "a78b0c3d-3f1a-9d1a-a0b8-78901c2d345b",
  // PersonaEdit = "b89c1d4e-4a2b-0e2b-b1c9-89012d3e456c",

  // MileStone
  MileStoneList = 'c90d2e5f-5b3c-1f3c-c2d0-90123e4f567d',
  MileStoneDelete = 'd01e3f6a-6c4d-2a4d-d3e1-01234f5a678e',
  MileStoneAdd = 'e12f4a7b-7d5e-3b5e-e4f2-12345a6b789f',
  MileStoneEdit = 'f23a5b8c-8e6f-4c6f-f5a3-23456b7c890a',

  // // PMO
  // PMOList = "a12d4c8f-7b5d-4e5d-b4d2-56789d6f789b",
  // PMODelete = "b23e5d9f-8c6e-4f6e-c5e3-67890e7f890c",
  // PMOAdd = "2b53f55f-95a5-41ea-a0ce-15ed09939e36",
  // PMOEdit = "35f6c6fa-a47f-4f9f-9cf8-f3dbc4f4eb84",

  // // ConsultationCompany
  // ConsultationCompanyList = "d200f2db-7bd3-4126-9ae7-41de568ea6d1",
  // ConsultationCompanyDelete = "20787f43-88dd-478e-afdd-620eab03d3f6",
  // ConsultationCompanyAdd = "3595b61b-1fb6-423f-b6f6-12af5ed2f75a",
  // ConsultationCompanyEdit = "b667d966-9b72-4e5e-c475-1ae79d05f7d3",

  //reports
  ReportList = '7d2b88d4-eee1-4296-9708-1e4997e1a930',

  // ResponsibleDepartment
  // ResponsibleDepartmentList = "a606830f-906d-4161-8b94-04d06aebbe34",
  // ResponsibleDepartmentDelete = "7c4f9dd6-4d69-4845-b189-2d74956d026b",
  // ResponsibleDepartmentAdd = "a6e31952-3033-4d96-97c5-cdf600f88800",
  // ResponsibleDepartmentEdit = "3ba1b0f7-096f-49a1-86f9-2b1a9eedf4a7",

  // Project Cr
  ChangeRequestList = '933c92b5-4555-4483-9316-8bfc07872987',
  ChangeRequestDelete = '7e499977-4d9c-46c6-92c6-54d97de64bb0',
  ChangeRequestAdd = '195173e3-201d-4045-8e98-7d440a90441e',
  ChangeRequestEdit = '86265199-6106-4eae-b710-50c2d0dc4beb',
  ChangeRequestApprove = '12dff93b-f7ba-430a-9c8c-dc920ef37000',

  UserManagement = '29986d9c-5c46-412a-85e4-74d05a21b963',
  SystemCode = '0b0e4add-d777-4c75-bedb-5f5537f80a5c',

  // MSM CheckList
  MSMCheckList = '2e44f984-5729-4161-9b86-d8421ce1bc77',
  ProjectHeadTasks = '3a9e3e7f-6a3c-4b1d-9e6a-0d8c9b0e1d2f',
  AgentDashboard = '60a3e0b5-b2c6-455e-b04d-9746ae5d89e9',

  Phead = 'f9d6d4ad-d9a2-4b8c-8a31-f2b4d0ae0eac',
  DAdmin = 'e7faa309-a70c-4b3e-9254-a698f55efe3a',
  PAdmin = 'a75d6161-003d-4db6-a477-d738012b3f40',
  GetDashBoardItemsScore = '0defaf26-2074-438f-95f4-c6879ad0a096',
  GetSchedule = 'eb210ca9-381f-4768-92c4-bebf41e9eb42',
}
